var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isAppReady ? _c('div', {
    class: [{
      'nav-hidden': _vm.$store.state.hideNav
    }, {
      'is-animating': _vm.isAnimating
    }, {
      'layout-switched': _vm.$store.state.isLayoutSwitched
    }],
    attrs: {
      "id": "app"
    },
    on: {
      "click": _vm.resetAppTimeout
    }
  }, [_c('div', {
    staticClass: "transition-overlay"
  }), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.$store.state.hideNav && _vm.isBottomBarVisible,
      expression: "!$store.state.hideNav && isBottomBarVisible"
    }],
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "overlay__inner"
  }), _c('div', {
    staticClass: "overlay__outer"
  }), _c('div', {
    staticClass: "overlay__sidebar"
  })])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    staticClass: "router-view"
  })], 1), _c('VBackground', {
    attrs: {
      "source": _vm.$store.getters.activeBackground
    }
  }), _c('BottomBar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.$store.state.hideNav,
      expression: "!$store.state.hideNav"
    }],
    attrs: {
      "nav-items": _vm.$store.getters.activeBottomBar
    }
  }), _c('SubBottomBar', {
    attrs: {
      "nav-items": _vm.$store.getters.activeSubBottomBar
    }
  }), _c('VSlides', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.$store.state.hideNav,
      expression: "!$store.state.hideNav"
    }],
    attrs: {
      "slides": _vm.$store.getters.activeSlides
    }
  }), _c('VTags', {
    attrs: {
      "tags": _vm.$store.getters.activePageTags
    }
  }), _c('LivingOptionTags', {
    attrs: {
      "living-options": _vm.$store.getters['property/activeLivingOptionTags']
    }
  }), _c('LivingOptionSubsections', {
    attrs: {
      "subsections": _vm.$store.getters['property/activeLivingOptionSubsections']
    }
  }), _c('LivingOptionProperties', {
    attrs: {
      "properties": _vm.$store.getters['property/activeLivingOptionProperties']
    }
  }), _c('PropertyModal', {
    attrs: {
      "property": _vm.$store.getters.activePropertyModal
    }
  }), _c('PropertySlider', {
    attrs: {
      "slides": _vm.$store.getters.activePropertySlides
    }
  }), _c('RightSidebar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.$store.state.hideNav,
      expression: "!$store.state.hideNav"
    }],
    attrs: {
      "content": _vm.$store.getters['sidebar/activeSidebar']
    }
  }), _c('ReferenceTagSlider', {
    attrs: {
      "tags": _vm.referenceTags
    }
  }), _c('ProductCountWidget'), _vm.$store.getters.activePage && _vm.$store.getters.activePage.type === 'card-grid' ? _c('CardGrid') : _vm._e(), _vm.$store.getters.activePage && _vm.$store.getters.activePage.type === 'video' ? _c('VVideos') : _vm._e(), _c('VFilter', {
    staticClass: "v-filter-legacy"
  }), _c('transition', {
    attrs: {
      "name": "fast-fade"
    }
  }, [_vm.$store.state.actions.showIframeUrl ? _c('IframeModal', {
    attrs: {
      "url": _vm.$store.state.actions.showIframeUrl
    }
  }) : _vm._e()], 1), _c('transition', {
    attrs: {
      "name": "fast-fade"
    }
  }, [_c('AssetViewer', {
    attrs: {
      "payload": _vm.$store.state.actions.showAssetSource,
      "tag": _vm.$store.state.actions.showAssetTag,
      "virtualTourUrl": _vm.$store.state.actions.showAssetvirtualTourUrl,
      "meta": _vm.$store.state.actions.meta
    }
  })], 1), _c('transition', {
    attrs: {
      "name": "fast-fade"
    }
  }, [_vm.$store.getters['property/activeVirtualTourUrl'] ? _c('VirtualTour', {
    attrs: {
      "url": _vm.$store.getters['property/activeVirtualTourUrl']
    }
  }) : _vm._e()], 1), _c('transition', {
    attrs: {
      "name": "fast-fade"
    }
  }, [_vm.$store.state.accessCodePrompt ? _c('AccessCodePrompt', {
    attrs: {
      "prompt": _vm.$store.state.accessCodePrompt
    }
  }) : _vm._e()], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }